<template>
	<AppSelect
		dense
		outlined
		:items="items"
		item-text="title"
		item-value="value"
		v-model="localValue"
		:menu-props="{ bottom: true, offsetY: true }"
	>
		<template v-slot:selection="{ item }">
			<Row class="flex-align-center">
				<h5 class="item-title">{{ item.title }}</h5>
				<h5 v-if="item.subTitle" class="item-subtitle ml-1">({{ item.subTitle }})</h5>
			</Row>
		</template>
	</AppSelect>
</template>

<script>
import VModelMixin from '@/mixins/VModelMixin';
export default {
	name: 'MigrationDialogSelect',
	mixins: [VModelMixin],
	props: { items: { type: Array } },
};
</script>

<style lang="scss" scoped>
.item-title {
	color: #292829;
	letter-spacing: 0px;
}
.item-subtitle {
	color: #29282980;
	letter-spacing: 0px;
}
</style>
